import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const UarrowDownRight = ({
  size,
  type,
  theme,
  className,
  dataTestId = "uarrow-down-right",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="m12.39 10-2.195-2.195a.667.667 0 0 1 .943-.943l3.333 3.334c.26.26.26.682 0 .942l-3.333 3.334a.667.667 0 1 1-.943-.943l2.196-2.195H5.667a4.333 4.333 0 0 1 0-8.667H10A.667.667 0 1 1 10 4H5.667a3 3 0 1 0 0 6h6.724Z" />
  </SVGIcon>
);
